import { render, staticRenderFns } from "./DocsDatasSetting.vue?vue&type=template&id=3a5e561a&scoped=true"
import script from "./DocsDatasSetting.vue?vue&type=script&lang=js"
export * from "./DocsDatasSetting.vue?vue&type=script&lang=js"
import style0 from "./DocsDatasSetting.vue?vue&type=style&index=0&id=3a5e561a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e561a",
  null
  
)

export default component.exports